export const addressTypeTranslations = {
  de: {
    noActive:
      'Keine aktive Adressart verfügbar. Aktivieren Sie eine Adressart in den Einstellungen.',
    title: 'Adressarten',
    description: 'Adressarten für Kundenadressen verwalten. Postfach ist bereits verfügbar.',
    add: 'Adressart anlegen',
    name: 'Bezeichnung',
    purpose: 'Verwendungszweck',
    order: 'Reihenfolge',
    translations: 'Mehrsprachige Bezeichnungen',
    active: 'Aktiv',
    inactive: 'Deaktiviert',
    saved: 'Adressart gespeichert.',
    saveError:
      'Adressart konnte nicht gespeichert werden. Prüfen Sie die Bezeichnung; der Verwendungszweck bereits verwendeter und vorbelegter Arten ist geschützt.',
    help: 'Hilfe zu Adressarten',
    loadError: 'Adressarten konnten nicht geladen werden.',
    invalidSelection:
      'Diese Adressart ist unbekannt, deaktiviert oder passt nicht zum Verwendungszweck.',
    usedPurpose:
      'Der Verwendungszweck einer verwendeten oder vorbelegten Adressart kann nicht geändert werden.',
    notFound: 'Adressart nicht gefunden.',
    concurrentChange: 'Die Adressarten wurden inzwischen geändert. Bitte neu laden.',
  },
  en: {
    noActive: 'No active address type is available. Enable one in settings.',
    title: 'Address types',
    description: 'Manage address types for customer addresses. PO box is already available.',
    add: 'Create address type',
    name: 'Name',
    purpose: 'Purpose',
    order: 'Order',
    translations: 'Translated labels',
    active: 'Active',
    inactive: 'Inactive',
    saved: 'Address type saved.',
    saveError:
      'Could not save the address type. Check its name; the purpose of used and built-in types is protected.',
    help: 'Address type help',
    loadError: 'Could not load address types.',
    invalidSelection: 'This address type is unknown, inactive or does not match the purpose.',
    usedPurpose: 'The purpose of a used or built-in address type cannot be changed.',
    notFound: 'Address type not found.',
    concurrentChange: 'Address types have changed. Please reload.',
  },
  fr: {
    noActive: 'Aucun type d’adresse actif. Activez un type dans les paramètres.',
    title: 'Types d’adresse',
    description: 'Gérer les types d’adresse des clients. Boîte postale est déjà disponible.',
    add: 'Créer un type d’adresse',
    name: 'Libellé',
    purpose: 'Usage',
    order: 'Ordre',
    translations: 'Libellés traduits',
    active: 'Actif',
    inactive: 'Désactivé',
    saved: 'Type d’adresse enregistré.',
    saveError:
      'Impossible d’enregistrer le type d’adresse. Vérifiez le libellé ; l’usage des types utilisés et prédéfinis est protégé.',
    help: 'Aide sur les types d’adresse',
    loadError: 'Impossible de charger les types d’adresse.',
    invalidSelection: 'Ce type d’adresse est inconnu, désactivé ou ne correspond pas à l’usage.',
    usedPurpose: 'L’usage d’un type d’adresse utilisé ou prédéfini ne peut pas être modifié.',
    notFound: 'Type d’adresse introuvable.',
    concurrentChange: 'Les types d’adresse ont changé. Rechargez la page.',
  },
  es: {
    noActive: 'No hay ningún tipo de dirección activo. Active uno en la configuración.',
    title: 'Tipos de dirección',
    description:
      'Gestionar tipos de dirección de clientes. Apartado de correos ya está disponible.',
    add: 'Crear tipo de dirección',
    name: 'Nombre',
    purpose: 'Uso',
    order: 'Orden',
    translations: 'Nombres traducidos',
    active: 'Activo',
    inactive: 'Desactivado',
    saved: 'Tipo de dirección guardado.',
    saveError:
      'No se pudo guardar el tipo de dirección. Revise el nombre; el uso de los tipos utilizados y predefinidos está protegido.',
    help: 'Ayuda sobre tipos de dirección',
    loadError: 'No se pudieron cargar los tipos de dirección.',
    invalidSelection:
      'Este tipo de dirección es desconocido, está desactivado o no corresponde al uso.',
    usedPurpose: 'No se puede cambiar el uso de un tipo de dirección utilizado o predefinido.',
    notFound: 'Tipo de dirección no encontrado.',
    concurrentChange: 'Los tipos de dirección han cambiado. Vuelva a cargar.',
  },
  tr: {
    noActive: 'Etkin adres türü yok. Ayarlarda bir adres türünü etkinleştirin.',
    title: 'Adres türleri',
    description:
      'Müşteri adresleri için adres türlerini yönetin. Posta kutusu zaten kullanılabilir.',
    add: 'Adres türü oluştur',
    name: 'Ad',
    purpose: 'Kullanım amacı',
    order: 'Sıra',
    translations: 'Çevrilmiş adlar',
    active: 'Etkin',
    inactive: 'Devre dışı',
    saved: 'Adres türü kaydedildi.',
    saveError:
      'Adres türü kaydedilemedi. Adı kontrol edin; kullanılan ve önceden tanımlı türlerin kullanım amacı korunur.',
    help: 'Adres türleri yardımı',
    loadError: 'Adres türleri yüklenemedi.',
    invalidSelection: 'Bu adres türü bilinmiyor, devre dışı veya kullanım amacıyla eşleşmiyor.',
    usedPurpose: 'Kullanılan veya önceden tanımlı bir adres türünün kullanım amacı değiştirilemez.',
    notFound: 'Adres türü bulunamadı.',
    concurrentChange: 'Adres türleri değişti. Lütfen yeniden yükleyin.',
  },
} as const;
